import { ArrowLeft, Camera, Globe, Carrot, Check, Drumstick, Egg, Gift, Sparkles, Wheat } from 'lucide-react';
import PhoneShot from '../ui/PhoneShot';
import { APP_SCREENS } from '../../appScreens';
import { WebAppLink } from '../WebAppCta';

const Hero = () => (
    <section className="hero-section">
        <div className="hero-blob hero-blob-coral" />
        <div className="hero-blob hero-blob-green" />
        <div className="hero-blob hero-blob-saffron" />
        <div className="site-container hero-grid">
            <div className="hero-copy">
                <div className="eyebrow"><Sparkles size={17} /> دستیار آشپزی هوشمند فارسی، روی اندروید و نسخه وب</div>
                {/* The lead line carries the brand and the primary search terms; the large two-line
                    tagline underneath stays the visual anchor. Both live inside the single H1 so the
                    page has exactly one heading that names what it is. */}
                <h1>
                    <span className="hero-h1-lead">هوش‌پز؛ ساخت دستور پخت با هوش مصنوعی</span>
                    موادت رو بگو،<br />
                    <span className="hero-h1-accent">غذات رو تحویل بگیر.</span>
                </h1>
                <p>
                    مواد اولیه را تایپ کن یا از آن‌ها عکس بگیر. هوش‌پز به‌عنوان یک دستیار آشپزی هوشمند،
                    با توجه به زمان، رژیم، حساسیت‌ها و وسایل آشپزخانه‌ات یک دستور پخت فارسی و کاربردی می‌سازد.
                </p>
                <div className="hero-actions">
                    <a className="button" href="#download">دریافت اپلیکیشن <ArrowLeft size={19} /></a>
                    <WebAppLink link="home_hero" className="button button-outline"><Globe size={19} /> نسخه وب هوش‌پز، بدون نصب</WebAppLink>
                </div>
                <div className="hero-trust">
                    <span><Check size={17} /> شروع بدون ثبت‌نام</span>
                    <span><Check size={17} /> مناسب فارسی‌زبان‌ها</span>
                    <span><Check size={17} /> موجود در مایکت و بازار</span>
                </div>
            </div>

            <div className="hero-visual">
                <div className="hero-plate" aria-hidden="true" />
                <PhoneShot screen={APP_SCREENS.cookbook} className="hero-phone-back" decorative />
                <PhoneShot screen={APP_SCREENS.newRecipe} className="hero-phone-front" eager />

                <div className="hero-sticker sticker-carrot" aria-hidden="true"><Carrot size={16} /> هویج</div>
                <div className="hero-sticker sticker-egg" aria-hidden="true"><Egg size={16} /> تخم‌مرغ</div>
                <div className="hero-sticker sticker-chicken" aria-hidden="true"><Drumstick size={16} /> مرغ</div>
                <div className="hero-sticker sticker-rice" aria-hidden="true"><Wheat size={16} /> برنج</div>

                <div className="hero-note hero-note-camera">
                    <span className="hero-note-icon green"><Camera size={19} /></span>
                    <span><b>یا فقط عکس بگیر</b><small>مواد را خودکار پیدا می‌کنیم</small></span>
                </div>
                <div className="hero-note hero-note-gift">
                    <span className="hero-note-icon saffron"><Gift size={19} /></span>
                    <span><b>۵ اعتبار هدیه</b><small>با ثبت‌نام شماره موبایل</small></span>
                </div>
            </div>
        </div>
    </section>
);

export default Hero;
